var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('v-alert',{attrs:{"type":_vm.type,"color":_vm.color,"outlined":_vm.outlined,"dense":"","border":"left","value":_vm.value,"transition":"scale-transition","prominent":_vm.prominent}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }